import React, { useState } from 'react';
import './PhoneNumberModel.css';
import { useNavigate } from 'react-router-dom';
import config from '../config/config';

const PhoneNumberModal = () => {
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async () => {
        if (!phone) return;

        try {
            const response = await fetch(`${config.apiUrl1}/api/users/create`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    full_name: '',
                    phone_number: '+998' + phone,
                    passport_number: '',
                }),
            });

            if (response.ok) {
                const userId = await response.text();
                localStorage.setItem('userId', userId);
                navigate('/verify-code', {
                    state: { userId, phone: '+998' + phone, flag: 'profile' },
                });
            } else {
                setMessage('Пользователь не зарегистрирован или произошла ошибка.');
            }
        } catch (error) {
            console.error('Ошибка при создании пользователя:', error);
            setMessage('Ошибка соединения с сервером.');
        }
    };

    const handleClose = () => {
        navigate('/');
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        value = value.slice(0, 9);
        setPhone(value);
    };

    return (
        <div className="modal-overlay1">
            <div className="modal1">
                <button className="close-icon1" onClick={handleClose}>×</button>
                <h2>Введите номер телефона</h2>

                <div className="phone-input-container1">
                    <span className="prefix1">+998</span>
                    <input
                        className="phone-input1"
                        type="text"
                        placeholder="__ ___ __ __"
                        value={phone}
                        onChange={handlePhoneChange}
                    />
                </div>

                <div className="button-container1">
                    <button className="submit-btn1" onClick={handleSubmit}>
                        Получить код
                    </button>
                </div>

                {message && <p className="error-message1">{message}</p>}
            </div>
        </div>
    );
};

export default PhoneNumberModal;
